module.exports = __webpack_public_path__ + "8c7fcb230970f16080d6b4b511398ffd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/product-grid.png
// module id = 803
// module chunks = 0